import React, { useState } from 'react';
import './tooltipInfo.css';
import { FaInfoCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';

const TooltipInfo = ({ text, position = 'top' }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      onFocus={() => setVisible(true)}
      onBlur={() => setVisible(false)}
      tabIndex={0}
    >
      <FaInfoCircle className="info-icon" aria-label="Mais informações" />
      {visible && (
        <div className={`tooltip-box tooltip-${position}`}>
          {text}
        </div>
      )}
    </div>
  );
};

TooltipInfo.propTypes = {
  text: PropTypes.string.isRequired,
  position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
};

export default TooltipInfo;